import SharedImageEditorModal from "../../shared/imageEditorModal/SharedImageEditorModal";

function ChatImageEditorModal({
  show = false,
  sourceFile = null,
  kind,
  title = "Редагувати зображення",
  onApply,
  onCancel,
  disabled = false,
  restoreFocusRef = null,
}) {
  return (
    <SharedImageEditorModal
      show={Boolean(show && sourceFile)}
      sourceFile={sourceFile}
      kind={kind}
      title={title}
      onApply={onApply}
      onCancel={onCancel}
      disabled={disabled}
      restoreFocusRef={restoreFocusRef}
      className="project-modal chat-image-editor-modal image-editor-modal"
      dialogClassName="chat-image-editor-modal__dialog"
      contentClassName="chat-image-editor-modal__content"
      bodyClassName="chat-image-editor-modal__body"
      testId="chat-image-editor-modal"
      titleId="chat-image-editor-title"
    />
  );
}

export default ChatImageEditorModal;
